import Locations from "./Container"

export default Locations
